import { render, staticRenderFns } from "./ContactsMapBlock.vue?vue&type=template&id=440d3586"
import script from "./ContactsMapBlock.vue?vue&type=script&lang=js"
export * from "./ContactsMapBlock.vue?vue&type=script&lang=js"
import style0 from "./ContactsMapBlock.vue?vue&type=style&index=0&id=440d3586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports